import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import axios from 'axios'
import { resolveBroadcastAuthUrl } from '@/services/apiConfig'
import {secureStorage} from '@/services/secureStorage'

window.Pusher = Pusher

const broadcastAuthUrl = resolveBroadcastAuthUrl()

const buildAuthHeaders = () => {
    const token = secureStorage.getItem('setIn')
    const headers = {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
    }

    if (token) {
        headers.Authorization = `Bearer ${token}`
    }

    return headers
}

const channelAuthorizer = (channel) => ({
    authorize(socketId, callback) {
        axios
            .post(broadcastAuthUrl, {
                socket_id: socketId,
                channel_name: channel.name,
            }, {
                withCredentials: true,
                headers: buildAuthHeaders(),
            })
            .then(response => {
                callback(false, response.data)
            })
            .catch(error => {
                callback(true, error)
            })
    },
})

const echoService = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER, // 👈 ESTA ES LA CLAVE
    wsHost: process.env.VUE_APP_PUSHER_HOST,
    wsPort: parseInt(process.env.VUE_APP_PUSHER_PORT),
    forceTLS: process.env.VUE_APP_PUSHER_SCHEME === 'https',
    encrypted: process.env.VUE_APP_PUSHER_SCHEME === 'https',
    disableStats: true,
    enabledTransports: ['ws'],
    authEndpoint: broadcastAuthUrl,
    authorizer: channelAuthorizer,
    auth: {
        headers: buildAuthHeaders(),
    },
    withCredentials: true,
})

echoService.refreshAuthHeaders = () => {
    const headers = buildAuthHeaders()

    if (echoService.options?.auth) {
        echoService.options.auth.headers = headers
    }

    if (echoService.connector?.options) {
        echoService.connector.options.auth = echoService.connector.options.auth || {}
        echoService.connector.options.auth.headers = headers
    }

    const pusherConfig = echoService.connector?.pusher?.config
    if (pusherConfig?.auth) {
        pusherConfig.auth.headers = headers
    }
}

export default echoService
